import { PreInquiry } from '@interhyp/module-preinquiry';
import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import '@interhyp/shared-preinquiry/esm/index.css';
import '@interhyp/module-preinquiry/esm/index.css';

import { Navigation, NavItems } from '../../navigation/Navigation';

export interface InquiryOverviewWrapperProps {
  currentUserId: string;
  providerId: string;
}

export function InquiryOverviewWrapper({
  currentUserId,
  providerId,
}: InquiryOverviewWrapperProps): JSX.Element {
  const { inquiryId } = useParams<{ inquiryId: string }>();

  const navigationItems: NavItems = useMemo(() => {
    return [
      { to: `/credit/inquiries/${inquiryId}`, translation: 'navigation.preInquiry' },
      { to: `/credit/inquiries/${inquiryId}/documents`, translation: 'navigation.documents' },
      {
        to: `/credit/inquiries/${inquiryId}/communication`,
        translation: 'navigation.communication',
      },
    ];
  }, [inquiryId]);

  return (
    <>
      <Navigation navItems={navigationItems} />
      <PreInquiry inquiryId={inquiryId} providerId={providerId} currentUserId={currentUserId} />
    </>
  );
}
